export function getHexagonSizeOnScreen(h3Resolution: number, zoomLevel: number, latitude: number) {
  const edgeLengthInMeters = {
    0: 1107e3,
    1: 418e3,
    2: 158e3,
    3: 59.5e3,
    4: 22.3e3,
    5: 8.39e3,
    6: 3.15e3,
    7: 1.19e3,
    8: 449,
    9: 168,
    10: 63.1,
    11: 23.7,
    12: 8.94,
    13: 3.36,
    14: 1.26,
    15: 0.474,
  }
  // Tamanho aproximado do hexágono em metros
  const edgeLength = edgeLengthInMeters[h3Resolution as keyof typeof edgeLengthInMeters] || 0
  // Metros para pixels na tela
  // 156543.03392 * cos(latitude * Math.PI / 180) / Math.pow(2, zoomLevel) é uma aproximação da resolução do mapa em metros por pixel
  const metersPerPixel =
    (156543.03392 * Math.cos((latitude * Math.PI) / 180)) / Math.pow(2, zoomLevel)
  const sizeInPixels = edgeLength / metersPerPixel
  return sizeInPixels
}
